<template>
    <b-card v-if="show" class="border-0 mh-100" bg-variant="info">
        <div class="font-weight-bold line-height-golden pl-1 h4">Opgrader dit abonnement</div>
        <b-row class="py-2">
            <b-col lg="9" md="9" sm="12">
                <div class="open-sans line-height-golden py-3 py-lg-3 py-md-3 h5">
                  Vil du gerne modtage anbefalinger fra tidligere kunder og inspirere potentielle kunder? Så er et Håndværker.dk abonnement måske noget for dig.
                </div>
                <b-btn variant="warning" class="rounded border-0 p-3 font-weight-bold" href="#/inbox?send=support&default=haandvaerker" style="font-size:14px;">
                  Kontakt os her for at høre nærmere
                </b-btn>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
export default {
  name: 'haandvaerker',
  props: [
  ],
  data () {
    return {
      show: false
    }
  },
  created () {
    if (localStorage.getItem('haaid') === '0') {
      this.show = true
    }
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// haandvaerker.vue?88e676f0